/*
 ------------------------------------------------------------------
|  Copyright (c) 2015 Izenda, Inc.                                 |
|  ALL RIGHTS RESERVED                                             |
|                                                                  |
|  The entire contents of this file is protected by U.S. and       |
|  International Copyright Laws. Unauthorized reproduction,        |
|  reverse-engineering, and distribution of all or any portion of  |
|  the code contained in this file is strictly prohibited and may  |
|  result in severe civil and criminal penalties and will be       |
|  prosecuted to the maximum extent possible under the law.        |
|                                                                  |
|  RESTRICTIONS                                                    |
|                                                                  |
|  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES           |
|  ARE CONFIDENTIAL AND PROPRIETARY TRADE                          |
|  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS              |
|  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET    |
|  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.                 |
|                                                                  |
|  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED      |
|  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE        |
|  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE       |
|  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT  |
|  AND PERMISSION FROM IZENDA INC.                                 |
|                                                                  |
|  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  |
|  ADDITIONAL RESTRICTIONS.                                        |
 ------------------------------------------------------------------
*/

/**
 * SourceTree component
 */
!(function() {
  var React = require('react');
  var EventUtils = require('EventUtils');

  var m = require('mobx');
  var observer = require('mobx-react').observer;
  var classnames = require('classnames');
  var connect = require('share/enhancers/Izenda.Connect');

  var Panel = require('share/components/controls/Izenda.Panel');
  var List = require('share/components/controls/Izenda.List');
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');
  var CollapsibleList = require('share/components/controls/Izenda.CollapsibleList');
  var SourceTreeItem = require('./Izenda.SourceTreeItem');
  var SearchTextBox = require('share/components/controls/Izenda.SearchTextBox');
  const { isEmpty, getOr } = require('lodash/fp');

  function createTreeItem(tree, props) {
    return function(node, showCheckbox) {
      return (
        <SourceTreeItem
          key={node.id}
          node={node}
          showCheckbox={showCheckbox}
          filter={tree.filter.text}
          showIcon={props.showIcon}
        />
      );
    };
  }

  /**
   * display TreeNode/TreeItem of QuerySourceTree
   * @param  {Object}  tree
   * @param  {Object}  querySourceNode
   * @param  {Object} props
   * @return {Object} TreeNode/TreeItem
   */
  function treeNode(tree, querySourceNode, props) {
    var treeItem = createTreeItem(tree, props);

    if(!isEmpty(querySourceNode.childNodes)){
      return (
        <CollapsibleList
          className="panel-group collapsible-list-items datasource"
          key={querySourceNode.id}
          autoCollapse={false}
          defaultExpand={true}
        >
          <CollapsibleList.Item expanded={true} key={querySourceNode.id}>
            <CollapsibleList.ItemHeader className="panel-heading">{treeItem(querySourceNode, false)}</CollapsibleList.ItemHeader>
  
            <CollapsibleList.ItemBody className="panel-body">
              <List className="list-group" key={querySourceNode.id}>
                {querySourceNode.childNodes.map(function(child) {
                  return treeNode(tree, child, props);
                })}
              </List>
            </CollapsibleList.ItemBody>
          </CollapsibleList.Item>
        </CollapsibleList>
      );
    }

    var parentNode = querySourceNode.parentNode || {};
    var showField = props.fieldLevel && parentNode.isFieldNode;
    var showQuerySource = props.querySourceLevel && parentNode.isTypeGroup && parentNode.isTypeGroup();

    if(showQuerySource || showField){
      return treeItem(querySourceNode, true);
    }

    return null;
  }

  function searchBox(tree) {
    var notifyChange = EventUtils.notifyChange;

    return (
      <div className="search-box">
        <SearchTextBox
          value={tree.filter.text}
          onChange={notifyChange(tree.setFilter.bind(tree), EventUtils.INPUT)}
        />
      </div>
    );
  }

  var SourceTree = React.createClass({
    propTypes: {
      tree: React.PropTypes.object.isRequired,
      querySourceLevel: React.PropTypes.bool,
      fieldLevel: React.PropTypes.bool,
      showIcon: React.PropTypes.bool
    },
    render: function() {
      var props = this.props;
      var tree = props.tree;

      return (
        <Panel className="workspace-tree">
          {searchBox(tree)}
          <div className="workspace-tree-wraper">
            <ScrollBox>
              {tree.root.map(function(treeRootItem) {
                return treeRootItem.childNodes.map(function(node) {
                  return treeNode(tree, node, props);
                });
              })}
            </ScrollBox>
          </div>
        </Panel>
      );
    }
  });

  module.exports = connect()(SourceTree);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/AdvancedSetting/SecurityRules/Izenda.SourceTree.jsx